import React from 'react';

const DownloadIcon = () => {
    return (
        <svg className="svg-inline" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 10.9766V12.2266C2.5 12.5581 2.6317 12.876 2.86612 13.1104C3.10054 13.3449 3.41848 13.4766 3.75 13.4766H11.25C11.5815 13.4766 11.8995 13.3449 12.1339 13.1104C12.3683 12.876 12.5 12.5581 12.5 12.2266V10.9766"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.375 7.22656L7.5 10.3516L10.625 7.22656"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 2.85156V10.3516"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DownloadIcon;
